module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("Enrollments")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": ""
    }
  }, _vm._l((_vm.enrollments), function(item, index) {
    return _c('v-card', {
      key: ("item-" + index),
      staticClass: "info"
    }, [_c('v-list', [_c('v-list-tile', {
      attrs: {
        "icon": ""
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("enrollment_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.enrollmentName)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.userIsCreator(index)) ? [_c('app-edit-enrollment-dialog', {
      attrs: {
        "enrollment": _vm.enrollment(index)
      }
    })] : _vm._e()], 2), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.onDeleteEnrollment(item)
        }
      }
    }, [_c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "to": '/enrollments/' + item.enrollmentId
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey'
      }
    }, [_vm._v("navigate_next")])], 1)], 1)], 1)], 1)], 1)
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49de812e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Enrollments/Enrollments.vue
// module id = 677
// module chunks = 1